<template>
  <div class="back-list">
    <div class="item-time">
      <i></i>
      {{listData.articleLiveCommentTime}}
    </div>
    <div class="item-content" v-html="listData.articleLiveCommentContent">
    </div>
  </div>
</template>
<script>
import { openArticle } from "@/utils/appMethods.js";
import { getTimer, format } from "@/utils/timer.js";
export default {
  props: {
    listData: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
  
  },
};
</script>
<style lang="less">
.back-list {
  .item-time { 
    margin: 15px 0 20px 0;
    color:#999;
    i{
      width: 5px;
      height: 20px;
      margin-right: 20px;
      display: inline-block;
      background-color: rgb(44, 113, 193);
    }
  }
  .item-content{ 
    color: rgb(68, 68, 68);
    font-size: 26px;
    line-height: 1.5;
  }
}
</style>
